import { Grid } from '@material-ui/core';
import Icon from '../../Icon';
import Handle from '../../Handler';
import ToolTip from '@material-ui/core/Tooltip';
import './style.css';
import { makeStyles } from '@material-ui/core/styles';
import { internalSystem, nodeKeysLabel } from "../../../../../../../config/common";
import { useDispatch, useSelector } from 'react-redux';
import helpers from '../../../helpers';
import NodeHelperPopup from '../../../../../dialogs/NodeHelperPopup';

const useStyles = makeStyles({
    image: {
        width: 77,
        height: 70,
        display: 'block',
        position: 'relative',
        top: 0,
        left: 17,
        marginTop: 15
    },
    label: {
        textAlign: 'right',
        color: '#000',
        display: 'block',
        fontSize: 17,
        fontFamily: 'Roboto, Helvetica',
        fontWeight: 500,
        position: 'relative',
    },
    labelDiv: {
        marginTop: "130px",
        pointerEvents: 'all'
    }
})


export default function EnterprisesApp({ props, iconStyle }) {

    const nodeData = props.data != undefined ? props.data : '';
    const classes = useStyles()
    const isNodeRight = props.xPos > (internalSystem.position.x + internalSystem.style.width);
    const title = props?.data?.subType !== undefined && props?.data?.subType !== '' ? nodeKeysLabel[props?.data?.subType] : helpers.nodeKeysLabel[props.type];

    return (
        <Grid row id={`node-${props?.id}`}>
            {/* <ToolTip title={<>{nodeData?.label}<br/>{`(Enterprise App)`}</>} > */}
                <Grid xs={12} container spacing={2} style={{pointerEvents: 'all'}}>
                    <Icon icon={props?.data?.icon} metaData={props.data} isCustomIcon={props?.data?.isCustomIcon} defaultIcon={'enterprises_app'} style={iconStyle} />
                    {nodeData?.showHelper && <NodeHelperPopup nodeData={nodeData} title={title} nodeId={props.id} nodeType={props.type} subType={props?.data?.subType} templateId={props?.templateId} customType={"Enterprise App"} />}
                
                </Grid>
            {/* </ToolTip> */}

            <Grid item xs={12} className={classes.labelDiv}><span className={classes.label}>{props.data.label}</span></Grid>

            <Handle type="source" className={classes.handle} position={isNodeRight ? 'left' : 'right'} id={isNodeRight ? 'left' : 'right'} node={props} />
        </Grid>
    )
}